import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton, SecondaryButton} from 'Components/Button';
import {Alert} from 'Components/Partials';

import MedicationsApi from 'Services/Api/ServiceUsers/ServiceUserMedications';

export default class Duplicate extends React.Component {
    /**
     * @var state
     */
    state = {
        working: false,
        alert: null,
    }

    /**
     * @method handleDuplicate
     * @return {Promise<void>}
     */
    handleDuplicate = async () => {
        const {medication} = this.props;

        this.setState({
            working: true,
            alert: null,
        });

        const response = await MedicationsApi.duplicate(medication.id);

        if (response.status !== 201) {
            this.setState({
                working: false,
                alert: {
                    type: 'error',
                    message: response.message
                },
            });

            return;
        }

        this.props.onClose();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {medication} = this.props;
        const {alert, working} = this.state;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    Duplicate Medication
                </ModalHeader>

                <ModalBody>
                    {alert !== null && (<Alert {...alert} />)}

                    <p className="text-center mb-4">
                        This copies <strong>{medication.name}</strong> and all of its MARS entries
                        into a new line called "{medication.name} (copy)".
                    </p>

                    <p className="text-center">
                        Update the name and dosage on either line afterwards. Both keep the same MARS history.
                    </p>
                </ModalBody>

                <ModalFooter alignment="center">
                    <SecondaryButton
                        text="Cancel"
                        onClick={this.props.onClose}
                        working={working}
                    />

                    <PrimaryButton
                        text="Duplicate"
                        onClick={this.handleDuplicate}
                        working={working}
                    />
                </ModalFooter>
            </Modal>
        )
    }
};
